import { api } from './http'

export function getTags() {
  return api.get('/front/tags')
}

// 管理员标签 API
export function getAdminTags(page = 1, size = 10, keyword = '') {
  return api.get('/admin/tags', { params: { page, size, keyword } })
}

export function createTag(tagData) {
  return api.post('/admin/tags', tagData)
}

export function updateTag(id, tagData) {
  return api.put(`/admin/tags/${id}`, tagData)
}

export function deleteTag(id) {
  return api.delete(`/admin/tags/${id}`)
}
